import { render } from "./contents.vue?vue&type=template&id=543693f8&scoped=true"
import script from "./contents.vue?vue&type=script&lang=js"
export * from "./contents.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-543693f8"

export default script